import { Core, Modal } from '@nsftx/systems-sdk';
import { logService } from '@/common/services/logger';

const LOG_PREFIX = '[deviceManagementModalService]';
let modalInstance: Modal | null = null;
let modalReady = false;

const initDmModal = (core: Core) => new Promise<void>((resolve, reject) => {
  const rejectTimeout = window.setTimeout(() => {
    reject(new Error(
      `${LOG_PREFIX} Modal instance did not receive ready event on init.`,
    ));
  }, 10000);
  modalInstance = new Modal(core);
  modalInstance.on('ready', () => {
    window.clearTimeout(rejectTimeout);
    modalReady = true;
    logService.debug(`${LOG_PREFIX} Modal module ready.`);
    resolve();
  });
});

const getModalInstance = (): Modal => {
  if (!modalInstance) {
    throw new Error(
      `${LOG_PREFIX} Modal instance is not initialized.`,
    );
  }

  if (!modalReady) {
    throw new Error(
      `${LOG_PREFIX} Modal instance did not receive ready event.`,
    );
  }

  return modalInstance;
};

const reboot = () => {
  const modal = getModalInstance();
  return modal.showModalDialog('reboot');
};

const poweroff = () => {
  const modal = getModalInstance();
  return modal.showModalDialog('poweroff');
};

const openConfigTool = () => getModalInstance().showModalDialog('system_configuration_tool');

const openNetworkConfig = () => getModalInstance().showModalDialog('nm_connection_editor');

const showIp = () => getModalInstance().showModalDialog('info_about_ip');

export {
  initDmModal,
  reboot,
  poweroff,
  openConfigTool,
  openNetworkConfig,
  showIp,
};
